import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { Button } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import FullScreenLoader from "UIComponents/FullScreenLoader";

import classes from "./Footer.scss";

import { setGlobalTrayEnabledState } from "Login/modules/LoginModule";
import { hideIntercom, showIntercom } from "modules/Services";

function Footer({
  closeModal,
  selectedUnit,
  onImportHandler,
  setGlobalTrayEnabledState,
  hideIntercom,
  showIntercom,
}) {
  const { t } = useI18n();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setGlobalTrayEnabledState(false);
    hideIntercom();
    return () => {
      setGlobalTrayEnabledState(true);
      showIntercom();
    };
  }, []);

  const onImportClick = async () => {
    const unitId = _.get(selectedUnit, "id", "");
    const unitFlowId = _.get(selectedUnit, "unitFlowId", "");

    const firstCourseWithCurrentAcademicYear = _.find(
      selectedUnit.courses,
      course =>
        _.some(_.get(course, "academicYears", []), "isCurrentAcademicYear")
    );
    let courseId;
    if (firstCourseWithCurrentAcademicYear) {
      courseId = _.get(firstCourseWithCurrentAcademicYear, "id", "");
    }

    const selectedUnitCurriculumProgram = _.get(
      selectedUnit,
      "curriculumProgram",
      ""
    );
    const selectedUnitCurriculumProgramId = _.get(
      selectedUnitCurriculumProgram,
      "id",
      ""
    );

    try {
      setLoading(true);
      const result = await onImportHandler(
        { unitId, unitFlowId, courseId, selectedUnitCurriculumProgram },
        selectedUnitCurriculumProgramId
      );
      if (result) {
        closeModal();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const isAddButtonDisabled = _.isEmpty(selectedUnit);

  return (
    <div className={classes.container}>
      {loading ? (
        <FullScreenLoader
          overlayContainer={classes.fullScreenLoaderContainer}
        />
      ) : null}
      <Button
        dsVersion="2.0"
        onClick={closeModal}
        variant="neutral"
        type="outlined"
        testId="appComponents-leIntoUnitImport-footer-cancel"
      >
        {t("common:cancel")}
      </Button>
      <Button
        dsVersion="2.0"
        shortcut={{ code: "Enter", shiftKey: true }}
        onClick={onImportClick}
        variant="progressive"
        disabled={isAddButtonDisabled}
        testId="appComponents-leIntoUnitImport-footer-add"
      >
        {t("common:add")}
      </Button>
    </div>
  );
}

const mapStateToProps = state => {
  const {
    LEIntoUnitImport: { selectedUnit },
  } = state;

  return { selectedUnit };
};

export default connect(mapStateToProps, {
  setGlobalTrayEnabledState,
  hideIntercom,
  showIntercom,
})(Footer);
